import React from 'react';

import "./Home.scss";
import { Article } from '../../elements/Article/Article';
import { Reviews } from "./Reviews/Reviews";
import CountOn from './CountOn/CountOn';
import { B2X } from './B2X/B2X';
import { Apiform } from '../../elements/Apiform/Apiform';
import { CallUs } from './CallUs/CallUs';

export const Home = ()=>{
    return (
        <section className="Home">
            <Article level={0} src="web-home" className="block landing"/>
            <B2X/>
            <CountOn/>
            <Article src="web-goal" className="block wall"/>
            <Reviews/>
            <CallUs/>
        </section>
    )
}

export default Home;
